import { render, staticRenderFns } from "./CustomerOrder.vue?vue&type=template&id=363709ce&scoped=true&"
import script from "./CustomerOrder.vue?vue&type=script&lang=js&"
export * from "./CustomerOrder.vue?vue&type=script&lang=js&"
import style0 from "./CustomerOrder.vue?vue&type=style&index=0&id=363709ce&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "363709ce",
  null
  
)

export default component.exports